import httpService from 'services/http/http.service';
import ApiUrl from 'enum/api-url.enum';
import { getDeviceGroupId } from 'utils/common/registerDevGroupID';

function getOrganizationGroupTemplateByGroup() {
  const group_id = getDeviceGroupId()
  return httpService.get(ApiUrl.ORGANIZATIONGROUPTEMPLATE + '?organization_group_id=' + group_id);
}

const obj = { getOrganizationGroupTemplateByGroup };

export default obj;
